export enum ReviewPurchaserType {
    // FIXME: According to the API doc, the purchaserType can be one of the following values:
    //  INCENTIVIZED_BUYER, BUYER, TESTER, SPONTANEOUS
    //  so we should update this enum accordingly.
    VERIFIED = 'verified',
    TESTER = 'tester',
    UNCONTROLLED = 'uncontrolled',
    SPONTANEOUS = 'spontaneous',
}

export const mapReviewPurchaserType = (purchaserType: string): ReviewPurchaserType => {
    const lowerCaseType = purchaserType.toLowerCase();

    switch (lowerCaseType) {
        case 'verified':
            return ReviewPurchaserType.VERIFIED;
        case 'tester':
            return ReviewPurchaserType.TESTER;
        case 'uncontrolled':
            return ReviewPurchaserType.UNCONTROLLED;
        case 'spontaneous':
            return ReviewPurchaserType.SPONTANEOUS;
        default:
            return ReviewPurchaserType.SPONTANEOUS;
    }
};
